var _g, _path, _g2, _g3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeroRightCircles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 544,
    height: 486,
    viewBox: "0 0 544 486",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_61_1038)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M545.943 487.973V258.282C545.943 258.282 425.5 249.347 401.401 350.789C377.301 452.231 440.821 487.973 440.821 487.973H545.943Z",
    fill: "url(#paint0_linear_61_1038)",
    fillOpacity: 0.7
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M544.943 193.581C544.943 193.581 454.443 204.581 384.943 293.081C325.186 369.175 340.443 487.081 340.443 487.081",
    stroke: "url(#paint1_linear_61_1038)",
    strokeOpacity: 0.5,
    strokeWidth: 4
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_f_61_1038)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 105,
    cy: 105,
    r: 100,
    fill: "url(#paint2_linear_61_1038)",
    fillOpacity: 0.7
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_f_61_1038)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 115,
    cy: 115,
    r: 80,
    fill: "url(#paint3_linear_61_1038)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_61_1038",
    x: 390.943,
    y: 253.081,
    width: 160,
    height: 239.891,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_61_1038"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_f_61_1038",
    x: -0.0000610352,
    y: 0,
    width: 210,
    height: 210,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5,
    result: "effect1_foregroundBlur_61_1038"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_f_61_1038",
    x: 26.9999,
    y: 27,
    width: 176,
    height: 176,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4,
    result: "effect1_foregroundBlur_61_1038"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_61_1038",
    x1: 470.943,
    y1: 258.081,
    x2: 470.943,
    y2: 487.973,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6DEFD"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_61_1038",
    x1: 417.943,
    y1: 314.081,
    x2: 384.159,
    y2: 294.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4EB3DE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.17,
    stopColor: "#37B5C5",
    stopOpacity: 0.83
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2474,
    stopColor: "#56C6DE",
    stopOpacity: 0.7526
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.568038,
    stopColor: "#60ABA7",
    stopOpacity: 0.431962
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.720687,
    stopColor: "#7BF7FF",
    stopOpacity: 0.279313
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.830545,
    stopColor: "#8DF1FF",
    stopOpacity: 0.169455
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.911283,
    stopColor: "#B3F1FF",
    stopOpacity: 0.0887166
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.954492,
    stopColor: "#B6E5F3",
    stopOpacity: 0.0455079
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4FFFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_61_1038",
    x1: 105,
    y1: 5,
    x2: 105,
    y2: 205,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C8EEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EBF7F9"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_61_1038",
    x1: 115,
    y1: 35,
    x2: 115,
    y2: 195,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0E3EE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C7DEEF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroRightCircles);
export default __webpack_public_path__ + "static/media/hero_right_circles.6f9570be1e52b7993f07547e80e91fae.svg";
export { ForwardRef as ReactComponent };